module.exports = __webpack_public_path__ + "media/images/medico-3fd06ce168d2301f6d3752812d5ccc70.svg";